import { IManufacturerResponse } from '@kcftech/prometheustypescriptapiclient';
import { dataSourceOrderBy } from 'custom_hooks/data_hooks/data_source/data_source';
import {
    ManufacturersFilter,
    useInfiniteManufacturersDataSource,
} from 'custom_hooks/data_hooks/data_source/manufacturersDataSource';
import { useEffect } from 'react';
import { AutoComplete, AutoCompleteValue } from 'shared/autocomplete/AutoComplete';
import { useAutoComplete } from 'shared/autocomplete/useAutoComplete';
import { getId } from 'utils/data';

export type ManufacturerAutoCompleteProps = Readonly<{
    value: AutoCompleteValue<IManufacturerResponse>;
    corporationId: string | undefined;
    onChange: (newValue: AutoCompleteValue<IManufacturerResponse>) => void;
}>;

const renderItem = (item: IManufacturerResponse) => item.Name;

export function ManufacturerAutoComplete({
    value,
    corporationId,
    onChange,
}: ManufacturerAutoCompleteProps) {
    const {
        results,
        isLoading,
        hasNext,
        loadNext,
        setFilter,
    } = useInfiniteManufacturersDataSource({
        name: 'manufacturer-autocomplete',
        defaultFilter: {
            corporationId,
            isApproved: true,
        },
        defaultSort: dataSourceOrderBy<IManufacturerResponse>('Name').value,
    });

    const {
        onChange: onChangeManufacturer,
        inputValue,
        onInputValueChange,
        reset,
    } = useAutoComplete({
        renderString: renderItem,
        setFilter,
    });

    useEffect(() => {
        onChangeManufacturer(value);
    }, [onChangeManufacturer, value]);

    return (
        <AutoComplete<IManufacturerResponse, ManufacturersFilter>
            caseInsensitive
            placeholder="Start typing or select a manufacturer..."
            value={value}
            results={results}
            isLoading={isLoading}
            loadNext={loadNext}
            hasNext={hasNext}
            inputValue={inputValue}
            renderItem={renderItem}
            renderString={renderItem}
            dataKey={getId}
            onChange={(newValue) =>
                onChangeManufacturer(newValue, () => onChange(newValue))
            }
            onInputValueChange={onInputValueChange}
            reset={reset}
            entityText="a Manufacturer"
            thingToType="the name of the Manufacturer"
        />
    );
}
